import React from 'react';
import { ImageIcon, QuoteIcon, StarIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { SectionHeading } from './ui/SectionHeading';
import { Carousel } from './ui/Carousel';
import { testimonios } from '../data/landing';
export function Testimonios() {
  return <section className="w-full bg-white py-12 sm:py-20" aria-labelledby="testimonios-titulo" data-id="element-193" data-mp="31118mt39aid3">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-194" data-mp="2w1oedna2290h">
        <Reveal data-id="element-195" data-mp="2w3948zlfd3s0">
          <SectionHeading eyebrow="Comunidad Deco Emprende" title={<span id="testimonios-titulo" data-id="element-197" data-mp="2r9wv7xt8b5kd">Ellas ya empezaron a crear</span>} data-id="element-196" data-mp="2w3rcyvp9xagt" />
        </Reveal>
      </div>

      <Reveal delay={0.1} className="mt-8" data-id="element-198" data-mp="2mcwn7hctjsqm">
        <Carousel ariaLabel="Carrusel de testimonios" data-id="element-199" data-mp="2m9ikg808thin">
          {testimonios.map(testimonio => <article key={testimonio.nombre} className="flex h-full flex-col rounded-3xl border border-rosa-100 bg-crema p-5 shadow-tarjeta" data-id="element-200" data-mp="2i86s3upzii6r">
              <QuoteIcon className="h-6 w-6 text-rosa-200" aria-hidden="true" data-id="element-201" data-mp="28bk9zdp1m58f" />
              <p className="mt-2 flex-1 font-sans text-base leading-relaxed text-tinta" data-id="element-202" data-mp="1ncks3bs74l4k">
                {testimonio.comentario}
              </p>

              {/* Espacio editable: cargá la captura real en data/landing.ts */}
              <div className="mt-4 overflow-hidden rounded-2xl border border-dashed border-rosa-200 bg-white" data-id="element-203" data-mp="1ecnz4xyrx03p">
                {testimonio.imagen ? <img src={testimonio.imagen} alt={`Captura del mensaje de ${testimonio.nombre}`} loading="lazy" className="w-full object-cover" data-id="element-204" data-mp="1jb7kaw5jm7v0" /> : <div className="flex items-center gap-2 px-3 py-4 text-suave" data-id="element-205" data-mp="2b25a9sgizecs">
                    <ImageIcon className="h-4 w-4 text-rosa-200" aria-hidden="true" data-id="element-206" data-mp="2b017jdud4le3" />
                    <span className="font-sans text-xs" data-id="element-207" data-mp="1x24bcijtmgzy">
                      Espacio para captura real
                    </span>
                  </div>}
              </div>

              <div className="mt-4 flex items-center justify-between border-t border-rosa-100 pt-3" data-id="element-208" data-mp="lm5z65tcjeui">
                <div data-id="element-209" data-mp="qn3d267bpmq7">
                  <p className="font-serif text-lg text-borgona" data-id="element-210" data-mp="qnljtwrm3jcd">
                    {testimonio.nombre}
                  </p>
                  <p className="font-sans text-sm text-suave" data-id="element-211" data-mp="2iki1ycx7qau">{testimonio.lugar}</p>
                </div>
                <span className="flex" aria-label="5 de 5 estrellas" data-id="element-212" data-mp="3tx02dzu5l6zi">
                  {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-terracota text-terracota" aria-hidden="true" data-id="element-213" data-mp="3oy6qgbuilo1g" />)}
                </span>
              </div>
            </article>)}
        </Carousel>
      </Reveal>
    </section>;
}